// Packages
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// Styles
import Styles from "./Styles/JournalCard.module.css";
// Images
import messageIcon from "../../../../Assets/Icons/comments-count-dark.png";
import viewCountIcon from "../../../../Assets/Icons/view-count-dark.png";
import blackBookmarkImage from "../../../../Assets/Icons/black-bookmark.png";
import blackSendMessageImage from "../../../../Assets/Icons/black-send-message.png";
import convertNumbersToPersian from "../../../../Utils/convertNumbersToPersian";

const JournalCard = ({
  item,
  isList,
  handleChangePosts,
  handleShareArticle,
  handleSaveArticle,
}) => {
  const {
    image,
    category,
    title,
    writer,
    _id,
    content,
    views,
    comments,
    kind,
  } = item;
  const contentRef = useRef(null);
  const [newText, setNewText] = useState("");
  useEffect(() => {
    if (contentRef) {
      setNewText(contentRef.current.innerText.slice(0, 120) + ". . .");
    }
  }, [contentRef]);

  return (
    <div
      className={`${Styles.container} ${
        isList ? Styles.responsiveContainer : {}
      }`}
    >
      <p
        style={{ display: "none" }}
        ref={contentRef}
        dangerouslySetInnerHTML={{ __html: content }}
      ></p>
      <div
        className={`${Styles.detailsContainer} ${
          isList ? Styles.listDetailsContainer : {}
        }`}
      >
        <p className={Styles.text} dir="rtl">
          {newText}
        </p>
        <div className={Styles.autherContainer}>
          <p>{writer}</p>
        </div>
        <div className={Styles.details}>
          <div className={Styles.socialsContainer}>
            <img
              src={blackBookmarkImage}
              alt=""
              onClick={() => handleSaveArticle(_id)}
            />
            <img
              className={Styles.sendIcon}
              src={blackSendMessageImage}
              alt=""
              onClick={() =>
                handleShareArticle(
                  `${process.env.REACT_APP_PUBLIC_URL}article/${
                    kind === "textual" ? "journal" : "visual"
                  }/${_id}`
                )
              }
            />
            {/* <img src={blackHeartImage} alt="" /> */}
          </div>
          <div className={Styles.iconsContainer}>
            <div className={Styles.iconContainer}>
              <img className={Styles.messageIcon} src={messageIcon} alt="" />
              <h5>{convertNumbersToPersian(comments.length.toString())}</h5>
            </div>
            <div className={Styles.iconContainer}>
              <img src={viewCountIcon} alt="" />
              <h5>{convertNumbersToPersian(views.count.toString())}</h5>
            </div>
          </div>
        </div>
      </div>
      <div className={Styles.imageContainer}>
        <div
          className={Styles.imageTitle}
          onClick={() => handleChangePosts(item)}
        >
          {category}
        </div>

        <Link
          to={`/article/${kind === "textual" ? "journal" : "visual"}/${_id}`}
        >
          <img
            src={`${process.env.REACT_APP_PUBLIC_PATH}uploads/images/${image}`}
            alt=""
          />
        </Link>
      </div>
    </div>
  );
};

export default JournalCard;
